<template>
    <div class="time-type">
        <el-select
            clearable
            class="select-box" v-model="value"
            placeholder="请选择"
            size="small"
            @change="handleClickChange(value)"
        >
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: "time-type",
        props: {
            form: Array,
            selected: [Number, String, Array]
        },
        watch:{
            form(vl){this.options = vl},
            options(vl){this.$emit('update:form',vl)},
            selected(vl){this.value = vl},
            value(vl){this.$emit('update:selected',vl)},
        },
        data(){
            return {
                options: this.form,
                value: this.selected
            }
        },
        methods: {
            handleClickChange(value){
                this.$emit('onTimesType', value)
            }
        }
    }
</script>
<style lang="scss" scoped>
.time-type{
    display: flex;
    width: 100%;

    .select-box{
        width: 100%;
    }
}
</style>
